import { render } from "./DiagnosisSection.vue?vue&type=template&id=a3543860&scoped=true"
import script from "./DiagnosisSection.vue?vue&type=script&lang=js"
export * from "./DiagnosisSection.vue?vue&type=script&lang=js"

import "./DiagnosisSection.vue?vue&type=style&index=0&id=a3543860&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3543860"]])

export default __exports__